import React from 'react';
import { Form, Col, Row, Button } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import { Link } from "react-router-dom";
import moment from 'moment';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';

const columns = [
    {
        dataField: 'DisplayID',
        sort: true,
        headerAttrs: {
            hidden: true
        }
    },
    {
        dataField: 'ItemDescription',
        formatter: (cell, row, rowIndex) => {
            console.log(row);
            console.log(cell);
            return '(' + row.ItemQuantity  + ') ' +  cell ;
        },
        sort: true,
        headerAttrs: {
            hidden: true
        }
    }];
class PartsDetailsCard extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            user: props.user,
            loadingData: false,
            data: props.data,
            lineItems: props.data.lineItems
        };
    }


    render() {
        return (
            <div class={this.props.class} style={this.props.style}>
                <Row style={{ paddingLeft: 5 }}>
                    <Col md={2} >
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{moment(this.state.data.CreatedDate).format('MM/DD/YYYY')}</Form.Label>
                        <br />
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.data.OrderNumber}</Form.Label>
                        <br />
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.data.DisplayID}</Form.Label>
                        <br />
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.data.PurchaseOrder}</Form.Label>
                    </Col>
                    <Col md={3} >
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold' }}>Shipping Address</Form.Label>
                        <br />
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.data.Address1}</Form.Label>
                        <br />
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.data.City}, {this.state.data.State}</Form.Label>
                        <br />
                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.data.Zip}</Form.Label>
                    </Col>
                    <Col md={4} style={{ marginTop: 3, marginBottom: 3, display: 'flex', flexDirection: 'column', padding: '0px 0px 0px 5px' }}>
                        <BootstrapTable
                            bootstrap4
                            remote
                            keyField="DisplayID"
                            classes="parts-line-item-table"
                            wrapperClasses="table-responsive"
                            data={this.state.lineItems}
                            columns={columns}
                            onTableChange={this.onTableChange}
                            hidden={this.state.lineItems.length == 0}
                            striped
                            hover
                        //noDataIndication={() => <NoDataIndication />}
                        />
                    </Col>
                    <Col md={3} style={{ marginTop: 3, marginBottom: 3, display: 'flex', flexDirection: 'column' }}>
                        <Button as={Link} to={{
                            pathname: "/order_inquiry",
                            state: {
                                user: this.state.user,
                                data: this.state.data
                            }
                        }} size="sm" style={{ backgroundColor:'#00973A'}} variant="primary">Order Inquiry</Button>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default PartsDetailsCard;